// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__230Ow","containerItemsCenter":"Skeleton_containerItemsCenter__2_Q2F"};